import * as htmlToImage from "html-to-image";

import { cn, getCSSVar } from "../utils/styling";
import { IconButton } from "./IconButton";

const buttonSizeClass = {
  "2xl": "!h-12 !w-12",
  lg: "!h-8 !w-8",
  md: "!h-8 !w-8",
  sm: "!h-6 !w-6",
  xl: "!h-10 !w-10",
};

const CAPTURE_IGNORE_ATTR = "data-capture-ignore";

export const CaptureComponent = ({
  buttonProps = {},
  className,
  color,
  iconProps = {},
  size = "sm",
  targetElement,
}) => {
  const captureScreenshot = () => {
    const options = {
      backgroundColor: getCSSVar("--color-surface-bright"),
      cacheBust: false,
      filter: (node) => !(node instanceof HTMLElement && node.hasAttribute(CAPTURE_IGNORE_ATTR)),
      quality: 1,
      style: { height: "auto", width: "auto" },
    };
    htmlToImage
      .toPng(targetElement(), options)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "component-screenshot.jpeg";
        link.click();
      })
      .catch(() => {
        //
      });
  };

  const { className: buttonClassName, onClick, ...restButtonProps } = buttonProps;
  const { className: iconClassName, ...restIconProps } = iconProps;

  return (
    <IconButton
      buttonProps={{
        variant: "tertiary",
        ...restButtonProps,
        [CAPTURE_IGNORE_ATTR]: "",
        className: cn(buttonSizeClass[size], "!rounded", className, buttonClassName),
        onClick: (event) => {
          onClick?.(event);
          captureScreenshot();
        },
      }}
      iconProps={{
        iconName: "CameraThick",
        size,
        ...restIconProps,
        className: iconClassName,
        color,
      }}
    />
  );
};
